import { defineMessages } from 'react-intl';

export default defineMessages({
  orderCancelled: {
    id: 'sku-orders.dashboard.order-cancelled',
    defaultMessage: 'Order cancelled',
  },
  fulfilled: {
    id: 'sku-orders.dashboard.fulfilled',
    defaultMessage: 'Fulfilled',
  },
  emailModalTitle: {
    id: 'sku-orders.dashboard.email-modal-title',
    defaultMessage: 'Email customer',
  },
  emailModalSubject: {
    id: 'sku-orders.dashboard.email-modal-subject',
    defaultMessage: 'Update regarding your {time}, {date} order at {venueName}',
  },
});
